var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1632 1616",
    width: 102,
    height: 101,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h1632v1616h-1632z",
    fill: "#FDFDFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(588,474)",
    d: "m0 0h17l21 2 34 6 20 6 19 8 14 8 17 12 14 12 8 7 13 13 9 12 6 9v4h2v3h2l8 13 5 5v2h2l5 10 5 14 2 17 2 33v65l7-4 13-8 7-4 11-7 6-3 9-5 12-7 17-7 11-4 13-4 10-4 9-1 13-2v-5l-2-1 2-2-5-7-10-8-11-9-14-12-14-10-20-12-15-8-16-7-3-2-13-4-17-6-8-3-4-2h15l27 9 28 12 11 6 20 12 16 12 14 12 12 11 5 5v3h2l7 17 8 9 4 4v2h2l4 9 3 6 1 8h2l3 18 2 17v66l-1 20-3 14-5 9-3 2 1-7 1-3 1-31 1-16v-22l-1-40-3-23-7-20h-4l-2 2-4-1 4-4h2v-9l-3-1-4-5-2-1h-9l-16 4-14 6-35 14-16 8-22 13-12 8-4 1v2l-3 1-5 5-12 13-4 7 1 2-4 5v4l4 4-1 3-8-2-6-2 1-3 3-2 1-4-7 4-7 6 2 2 24 3 25-1 13-4 5-3 7-3 8-4 9-6 5-3h3v-2l9-5 7-6 11-8 10-9 5-3 11-10 3-4h2v-2l7-3h3v2h-2l-2 4-15 16-11 9-13 10-17 12-25 14-19 10-6 4-7 1v2l6 1 11 4 13 5 17 7 4 2v2l5 1v2h3v2l4 1v2l6 2 8 7 4 2v2l4 2 15 14 8 9 7 9 3 4-1 2-5-5-6-4-7-8-8-7-7-7-19-14-5-4-7-4-8-5-11-6-10-4-13-6-15-6-19-2h-20l-8 4-2 3 11 9 10 7v2l4 1 5 3v2l3 1 7 8 7 6v2l4 1v2l4 1 3 2v2l5 2 11 7 14 8 10 5 16 6 33 11 21 3 2 1h7l2-1 17-1 24-3 16-5 24-10 14-7 10-6 14-9 14-11 19-19 13-18 7-11 8-11 6-11 5-14 3-8 3-13 2-19 1-18v-17l-1-18-4-25-7-21-12-26-10-16-11-14-12-14-13-12-10-8-12-9-15-9-17-8-13-5-29-6v-2l-25-2v-1h32l23 5 13 4 9 4 7 3v2l9 3 9 6 12 9 11 9 12 11 12 12 6 7 12 17 1 4h2l6 11 8 17 8 23 4 21 1 13v50l-1 12-8 28-9 21-6 11-12 18-13 19-9 10-8 7-7 7-20 14-22 12-20 9-19 7-20 5h-17l-5 2-3-3-4-1v2l-10 1-4 1-22-3-6-2-10-2-9-3-20-7-14-7-9-5-13-8-7-4-6-5-11-6-7-3v50l-1 29-2 21-4 12-4 6-5 2 1-6 3-5 2-15 1-16 1-55 1-20 3-4-6-10-1-4-3-1-7-10-3-3-5-4-6-7-7-2 4-4 9-3 1-3h-13l-11 2-11 1-3 2-12 1-19 7-25 13-18 11-16 11-15 13-21 21-10 15-7 13-5 16-4 10-6 25-3 18-1 13v14l1 19 4 26 3 15 4 10 3 8v3h2l3 8 6 13 5 9 11 14 9 10 10 9v2l4 2 10 9 11 8 15 9 19 10 16 6 17 5 18 3 10 1h31l27-3 21-5 12-5 18-8 16-9 14-10 14-12 13-14 8-5h5l-2 6-11 10-8 7-8 8-14 10-21 13-18 8-21 8-23 5-17 2h-43l-21-3-18-5-9-4-13-5-13-7-12-7-11-8-14-11-10-9-13-13-10-12-5-7-6-11-11-21-5-16-6-20-3-28v-44l2-12 4-22 6-18 4-9 2-8 6-12h2v-3h2l1-4 5-9 11-12 18-18 14-11 12-9 6-4h2v-2l9-5 7-5 11-6 11-5 13-5-14-9v-2l-9-3-15-8-18-11-14-10-11-9-12-11-9-10-7-12 1-2 13 11 7 8 16 15 13 10 21 13 5 2v2l6 2 5 3 7 3 4 3 5 2 12 5v2h24l6-3h2v-2l5-2-2-8-2-1-5-9-8-11-17-12-13-8-10-6-17-11-16-8-16-6-14-6-14-7-15-5v-1l9 1 26 9 20 7 12 5 19 10 9 5 9 7 3 1v2l7 2 7 6 6 3v2l4 2 3 1v-72l2-21v-11l2-2 4-15 2-6 3-4h2l-2 10-2 16-2 7-1 9-1 90 3 5 6 15 4 5 4 2 4-1 12-9 6-11 3-4v-49l-3-69-1-14-2-6h-2l-4-7-3-3-3 7h-3l1-5h2v-10l-5-6-3-1v-2h-6l-49 17-21 9-19 9-17 11-26 20-15 14-13 15-6 11-6 17-6 16-3 15-4 36v56l2 16 2 25h-2l-2 7h-2l-1-12-3-16-1-2-1-9v-47l1-22 2-16 2-21 3-9 2-10 5-11 4-10 1-2h2l2-5h2v-3h2l1-4 3-7h2l2-5 11-11 8-7 10-9 17-13 7-6 6-3 13-8 15-7 8-4 13-5 14-5 21-5 13-4 2-1-1-6-4-6-8-7-10-9-16-15-14-11-10-7-14-8-15-7-23-7-33-6-15-2h-22l-36 9-19 7-18 8-15 9-12 9-11 9-16 16-7 8-11 14-11 17-11 22-7 19-3 13-1 8v42l1 17 5 37 4 12v2h-7l-2-1-3-9-2-14-2-25-1-6v-48l3-23 6-20 11-23 5-8 1-3h2l2-6 10-14 12-13 2-3h2l2-4 17-16 14-10 9-6h2v-2l11-6 16-8 15-6 21-6z",
    fill: "#9F9F9F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(854,89)",
    d: "m0 0h27l15 2 15 4 15 8 9 7 8 8 6 9 6 13 4 15v24l-4 26-2 5-5 17-1 2h-2l-2 5-6 10-9 11-7 6-12 8-15 5h-25l-18-3-15-4-7-4-1-2v-18l4-26 8-48 8-55 4-20z",
    fill: "#FCFCFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(706,1319)",
    d: "m0 0h31l33 2 3 1v14l-4 32-8 47-1 11-1 3-2 19-4 26-3 17-2 9-5 6-11-1-27-7-21-7-10-6-10-9-7-8-9-17-2-12-1-11v-33l3-14 7-21 11-18 10-12 7-5 11-4z",
    fill: "#FCFCFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(210,439)",
    d: "m0 0h10l13 5v2l6 2 6 7 9 14 6 11v11l-9 16-8 16-6 13h-2l-1 5-5 12h3v2h2l1-8 6-11 8-13 9-19 8-13 6-7 10-6 13-2h12l9 3 8 4v2l4 1v2l5 2 8 10 6 12v17l-4 15-5 11-4 9-5 10-5 13-6 9-3 3-5-1-54-28-26-13-5-3-7-3-20-9-19-9-19-10-7-6 1-8 8-16 13-23 10-14 9-10 12-6z",
    fill: "#FCFCFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1282,989)",
    d: "m0 0 8 1 13 5 16 7 30 15 20 12 20 8 11 5 12 6 8 3 17 9 7 3 1 5-3 5-3 10-8 15-9 16-5 8h-2l-1 4-10 11h-2v2l-10 5-3 1h-13l-13-6-5-5-2-4-3-1v-3h-2v-3l-4-2-5-8-3-9-1-10 5-12 6-10 8-16 8-21 2-4h-3l-2 5-4 7-6 11-3 7-5 12-9 14-6 10-6 5-13 5-9 2-10-1-13-4-10-6-10-11-5-10-2-5v-15l5-16 8-20 10-22 7-9z",
    fill: "#FCFCFC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(753,835)",
    d: "m0 0h2l1 8 1 76 2 28 5 11v29l-9-1-27-6-20-7-16-8-17-9-16-12-11-9-13-12-4-4v-2h-2l-2-6v-6l5-8 7-3 18-7 11-5 19-8 21-11 20-12 18-11z",
    fill: "#FBFBFB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(772,785)",
    d: "m0 0h15l-5 5-10 5v1l7 2 8 9 5 3 6 9 4 4 4 7 4 8h-2l-1 3-1 20-1 55-2 27-3 8-3 7 5-2-6 7-7 8-2 6h-2l-1 8-4 5-8 1-26-1-16-3-11-4-9-3-14-6-12-7-11-6-12-8-11-9-8-6-17-17-1-4h-2v-3l6-3 1 6h2l7 8 13 12 17 13 14 9 23 12 19 7 26 6 14 3-1-29-5-11-2-28-1-84-6 4-23 14-13 8-18 10-17 8-19 8-12 5-8 3-3-1 6-5 12-6 13-5 9-5 7-3 20-11 6-4h3v-2l12-7 14-10 11-9 8-7 4-5 2-7v-11l-11-7-4-1 2-1 15-2z",
    fill: "#FAFAFA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1262,352)",
    d: "m0 0h20l13 5 10 8 5 6v2h2l6 12 3 11v16l-5 12-9 11-11 7-14 5-6 1h-16l-11-3-8-4-5-5v-2h-2l-6-10-5-14-2-8v-10l4-11 5-9h2l2-5 6-5h2v-2l8-5z",
    fill: "#9F9F9F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(320,1140)",
    d: "m0 0h24l13 5 9 8v2h2l8 16 2 8v23l-3 8-6 9-8 7-7 4-11 3-11 1h-9l-11-2-11-6-8-9-6-11-2-8v-23l4-12 3-6h2l2-5 11-8z",
    fill: "#D5D5D5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(946,678)",
    d: "m0 0h9l6 5 3 3 1 7-1 2h-2l-1 3-2 1 1 2-11 5-10 2v2l-5 5-13 12-5 3-10 9-9 6h-2l-2 4-9 6h-3v2l-10 5-10 7-8 4-8 3-7 3-7 2-25 1-24-3-3-3 12-10h3l-1 5-3 1 1 3 12 3-1-4-3-2 1-5 3-5-1-2 7-9 11-12 4-4h3v-2l7-4 14-9 21-12 16-8 26-10 21-9z",
    fill: "#FBFBFB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(789,788)",
    d: "m0 0h20l19 2 10 4 11 5 13 6 10 4 6 4 9 5 11 8 14 10 12 11 14 13v2l5 2 3 3v2l6 2 6 9 2 7-4 2h-7l-10-2-17-3-38-13-9-4-26-14-12-8v-2l-4-2-3-1-1-2-3-1-5-5-6-7-6-5v-2l-5-2-4-2-5-5-10-7-7-6 5-5z",
    fill: "#FBFBFB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(588,474)",
    d: "m0 0h17l21 2 34 6 20 6 19 8 14 8 17 12 14 12 8 7 13 13 9 12 6 9v4h2v3h2l1 5-4-2-3-1v-2h-6l-49 17-21 9-19 9-17 11-26 20-15 14-13 15-6 11-6 17-6 16-3 15-4 36v56l2 16 2 25h-2l-2 7h-2l-1-12-3-16-1-2-1-9v-47l1-22 2-16 2-21 3-9 2-10 5-11 4-10 1-2h2l2-5h2v-3h2l1-4 3-7h2l2-5 11-11 8-7 10-9 17-13 7-6 6-3 13-8 15-7 8-4 13-5 14-5 21-5 13-4 2-1-1-6-4-6-8-7-10-9-16-15-14-11-10-7-14-8-15-7-23-7-33-6-15-2h-22l-36 9-19 7-18 8-15 9-12 9-11 9-16 16-7 8-11 14-11 17-11 22-7 19-3 13-1 8v42l1 17 5 37 4 12v2h-7l-2-1-3-9-2-14-2-25-1-6v-48l3-23 6-20 11-23 5-8 1-3h2l2-6 10-14 12-13 2-3h2l2-4 17-16 14-10 9-6h2v-2l11-6 16-8 15-6 21-6z",
    fill: "#1C1C1C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(618,700)",
    d: "m0 0 8 6 6 5 7 8 16 15 13 10 21 13 5 2v2l6 2 5 3 7 3 4 3 5 2 12 5v2h8l4 3 5-1h10l2 3-4 2-10 2-1 1-12 1-19 7-25 13-18 11-16 11-15 13-21 21-10 15-7 13-5 16-4 10-6 25-3 18-1 13v14l1 19 4 26 3 15 4 10 3 8v3h2l3 8 6 13 5 9 11 14 9 10 10 9v2l4 2 10 9 11 8 15 9 19 10 16 6 17 5 18 3 10 1h31l27-3 21-5 12-5 18-8 16-9 14-10 14-12 13-14 8-5h5l-2 6-11 10-8 7-8 8-14 10-21 13-18 8-21 8-23 5-17 2h-43l-21-3-18-5-9-4-13-5-13-7-12-7-11-8-14-11-10-9-13-13-10-12-5-7-6-11-11-21-5-16-6-20-3-28v-44l2-12 4-22 6-18 4-9 2-8 6-12h2v-3h2l1-4 5-9 11-12 18-18 14-11 12-9 6-4h2v-2l9-5 7-5 11-6 11-5 13-5-14-9v-2l-9-3-15-8-18-11-14-10-11-9-12-11-9-10-7-12z",
    fill: "#1C1C1C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(163,839)",
    d: "m0 0h80l50 2 2 1-2 5-14 11-14 8-26 17-15 9-25 14-29 16-22 13-15 10-9 5 12-1h55l50 2 10 1 25 1 24 2 6 1 17 1-1 6-7 6-16 9-20 12-14 8-21 10-19 10-20 10-19 10-35 18-11 5h-2v-6l4-4 14-7 23-11 19-10 10-5 17-9 12-6 11-6 8-3 15-8 17-9 10-7 14-7 1-1-23-1-28-2-18-1-67-2-67-1-1-2 8-8 11-6 21-12 15-9 12-7 11-6 17-10 9-5 7-4 9-5 15-9h2v-2l9-5 15-10 11-7 2-2-8 1-189 1-1-8z",
    fill: "#1A1A1A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1452,522)",
    d: "m0 0h4l-1 6-9 6-31 15-19 10-26 14-19 10-47 23-14 8-12 6-1 2h10l7 1 19 1 78 1 54 3 38 1-1 5-17 9-16 11-15 9-22 13-24 14-25 14-22 12-15 10-10 7-7 4h59l26-1 114-2v6l-3 3-56 1h-142l-10-1 1-4 2-4 5-4h3v-2l11-6 18-12 12-6 15-9 41-24 13-8 16-9 8-5 22-13 2-2-56-1-46-2-28-1-13-1-26-1-16-2-9-2-5-2v-3l5-4 16-8 6-4 11-6 17-8 16-8 22-12 16-8 10-6 16-8 18-10 19-10 10-5z",
    fill: "#202020"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(208,432)",
    d: "m0 0h16l12 4 11 8 6 8 7 18 3 8 2 3 7-2 14-8 5-2h19l17 7 10 6 8 7 4 6 5 16v8l-3 17-5 16-10 21-8 16-10 15-3 3h-5l-10-6-32-16-19-10-16-8-14-6-16-8-12-5-15-8-12-6-14-8-5-3-2-4 4-9 8-16 10-19 12-19 12-13 8-7zm2 7-11 4-8 6-10 12-9 14-11 20-7 14-1 8 7 6 15 8 23 11 20 9 10 4 8 5 32 16 19 10 25 13 4-1 6-7 6-13 3-7 7-16 5-11 4-15v-17l-6-12-8-10-5-2v-2l-4-1-1-3-8-4-8-2h-12l-13 2-10 6-8 10-10 18-8 16-9 15-3 7v5h-2v-2h-3l5-12 1-5h2l10-21 9-17 4-7v-11l-10-18-9-12-6-4h-2v-2l-13-5z",
    fill: "#1B1B1B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(702,1313)",
    d: "m0 0h41l35 2 5 1-2 27-2 21-6 36-4 27-6 42-3 25-4 16h-20l-25-5-14-3-9-4-11-4-13-9-12-12-7-10-7-16-3-9-1-6v-26l4-22 6-19h2l1-6 6-12h2l1-4 6-8 5-5 11-10 12-5zm4 6-15 3-10 4-7 6-8 10-11 18-8 24-2 11v33l2 17 2 8 8 15 11 12 10 8 11 5 24 7 19 5 11 1 5-6 3-12 5-36 2-11 1-12 1-3 2-16 8-48 3-26v-14l-3-1-33-2z",
    fill: "#2E2E2E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1279,978)",
    d: "m0 0 4 1 36 15 23 11 22 12 36 17 18 8 29 14 8 6-1 4-6 10-15 32-15 23-8 9-10 7-16 5-1 1h-7l-16-6-4-2-11-15-10-19-2-10v-2l-2-1-1 2-12 6-9 6-9 4-15-1-12-5-13-9-7-7-6-12-3-16 3-17 6-17 6-14 8-16 10-17zm3 11-6 7-8 16-9 21-7 20-1 4v15l5 12 9 11 9 7 10 4 11 3 11-1 12-4 6-3 6-5 5-9 10-16 5-12 8-16 5-9 1-3h3l-6 14-7 18-9 16-6 12-1 7 3 12 4 8 4 5h2v3h2l1 4h2l2 4 7 6 11 5h13l11-5 2-1v-2l4-2 9-10v-3h2l12-20 12-24 3-9 1-4-3-3-21-10-5-3-10-4-9-4-10-5-18-7-10-6-18-10-30-15-17-7-7-2z",
    fill: "#191919"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(967,480)",
    d: "m0 0h32l23 5 13 4 9 4 7 3v2l9 3 9 6 12 9 11 9 12 11 12 12 6 7 12 17 1 4h2l6 11 8 17 8 23 4 21 1 13v50l-1 12-8 28-9 21-6 11-12 18-13 19-9 10-8 7-7 7-20 14-22 12-20 9-19 7-20 5h-17l-5 2-3-3-4-1v2l-10 1-4 1-22-3-6-2-10-2-9-3-20-7-14-7-9-5-13-8-7-4-8-7v-1h5l9 4 17 10 17 9 16 6 33 11 21 3 2 1h7l2-1 17-1 24-3 16-5 24-10 14-7 10-6 14-9 14-11 19-19 13-18 7-11 8-11 6-11 5-14 3-8 3-13 2-19 1-18v-17l-1-18-4-25-7-21-12-26-10-16-11-14-12-14-13-12-10-8-12-9-15-9-17-8-13-5-29-6v-2l-25-2z",
    fill: "#1C1C1C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(845,81)",
    d: "m0 0h13l18 1 21 3 15 4 12 5 14 9 12 12 7 11 6 15 4 17v20l-3 22-6 23-8 16-13 17-14 11-16 8-16 5h-24l-13-3-17-4-15-5-2-2v-24l4-32 6-35 3-17 8-52zm9 8-4 13-8 53-7 45-6 35-1 8v18l4 4 11 4 18 4 8 1h25l15-5 16-11 10-11 7-11 3-5v-2h2l5-14 2-9 2-6 3-21v-24l-5-17-8-16-11-12-9-7-15-8-21-5-9-1z",
    fill: "#1C1C1C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(747,78)",
    d: "m0 0h2l-1 7-27 4-61 9-20 4 4 22 8 41 3 20 66-11 25-5h5v6l-10 3-62 10-17 2h-6l7 39 2 11 7 36 2 3h7l20-3 37-6 25-5 14-4h6v5l-7 3-37 8-64 10-9 2h-8l4-5-1-11-6-30-6-29-3-20-1-1-4-24-5-28-3-15-3-23-2-4 8-3 35-6 21-4 19-3 21-3z",
    fill: "#313131"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1090,148)",
    d: "m0 0h18l18 6 14 8 11 9 8 9 6 10 5 13 2 15v10l-5 5-5 1-1-5 3-8v-7l-5-17-6-12-9-10-10-8-12-7-17-5h-8l-11 2-11 6-7 7-6 10-3 7v10l7 15 5 8v2l3 1 8 10 12 13 6 8 5 5 7 8 10 17 5 13v14l-4 9-6 9-8 8-12 7-14 4h-19l-11-4-12-6-13-9-15-15-9-14-6-18-1-6v-9l6-7h4v27l5 12 7 11 9 10 9 8 11 7 14 5 13 2 11-1 15-6v-2l7-6 4-5 1-2h2v-3h2l1-4 2-3-1-8-5-12-6-11-8-10-9-10-7-8-10-11-11-14-10-16-5-15 1-6 3-8 6-11 8-10 3-1v-2l8-5z",
    fill: "#2E2E2E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(932,1297)",
    d: "m0 0h6l2 20 5 34 3 12 4 23 2 12 9 49 6 30 3 7v4l-21 5-41 7-30 5-25 5h-4v-5l7-2 24-5 52-9 29-5-5-13-5-22-2-9-2-10-3-22-1-5h-8l-38 6-44 9h-7l1-5 7-3 20-3 41-8 15-2 3-1h8l-6-34-7-39-1-18-39 7-39 8-24 4h-9l-1-1v-5l28-4 27-5 27-6 17-3z",
    fill: "#313131"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(513,1244)",
    d: "m0 0h19l19 5 14 7 13 10 6 5 8 11v2h2l6 15 4 17v9l-4 5-5-1-1-1v-14l-3-16-4-10-9-13-5-4-2-1v-2l-5-2-6-4-12-6-11-4-5-1h-15l-10 3-10 6-6 7-7 14v16l6 12 7 11 3 3 9 11 25 25v2h2l4 7 1 3h2l5 9 6 17-3 10-6 12-9 10-10 6-19 6h-15l-16-4-15-9-12-11-7-8-6-10-3-9-3-12v-16l3-3 6-1 3 2-1 12-2 10 3 11 4 8 4 6 9 10 9 8 12 6 9 3 10 2h7l17-8 4-2 4-4h2v-2l3-2 2-4h2l1-5 3-6v-8l-5-13-9-14-10-11-7-8-17-17-11-14-8-16-2-5v-17l5-12 1-2h2l1-4 1-2h2l2-4 3-3h2v-2l8-4z",
    fill: "#1B1B1B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1306,825)",
    d: "m0 0h8l26 4 60 8 24 3 30 3 13 2 15 2 19 3 1 3-2 3-6 44-10 58-3 9-3 2h-4l3-12 8-41 5-37 1-8v-13l-25-4-34-4-18-2h-9v22l-3 37-2 32-1 2h-7l-2-2 2-9 3-24 2-23 1-18 3-19-27-3-26-4-24-3h-11l-3 19-3 24-4 30-4 25-3 6-8 1 3-9 3-17 6-38 4-35z",
    fill: "#1A1A1A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(114,618)",
    d: "m0 0h7l-1 5-6 27-6 39-4 37 12 1 67 10h6l-2-3v-9l9-57 2-24 1-1h6l1 2-5 42-3 24-4 22v5l45 6 23 4 20 3 5-27 5-38 3-32 3-12h5v11l-7 57-7 41-1 9-16-1-26-5-19-3-21-3-22-2-40-6-26-4-22-3-2-1v-4l3-3 4-39 5-32 6-31z",
    fill: "#1B1B1B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1196,1139)",
    d: "m0 0h34l11 2v4l-3 2h-22l-3-1h-16l-15 4-10 5-11 8-3 1-2 4-9 13-4 8-4 11v14l7 13 1 3h2l2 5 4 2 5 6 7 4 6 2h9l18-7 19-10 16-8 12-5 20-6 8-1h11l9 2 8 3 5 4 3 4v2h2l4 7 5 15v13l-4 12-6 11-7 9-10 11-10 7-14 7-12 4-27 1-6-3-4-5-3-6v-3l7 1 6 4 11 4h14l14-4 12-6 11-9 9-11 8-13 3-12v-7l-3-12-6-10-4-5-3-1v-2l-8-1-9-2h-13l-12 3-20 8-22 11-26 11-13 3-13-3-6-3v-2l-4-2-7-6-7-11-5-11-1-3v-14l3-11 8-16 11-13 9-8 14-9 13-5z",
    fill: "#1C1C1C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(348,259)",
    d: "m0 0 15 2 14 5 4 3-1 4-5 4-4-2-6-4-14-5-9 1-12 3-12 6-10 8-7 7-9 13-6 11-1 4v12l6 14 8 10 10 7 6 3h15l10-3 10-5 10-4 16-8 20-9 6-3 16-4h12l16 7 8 6 7 9 4 9 3 9v17l-4 14-8 11-17 17-13 8-13 6-21 3h-17l-12-2-2-1v-6l1-2 8 1 9 2h26l20-6v-2l7-4 10-9 3-1 2-4 9-11 5-9 1-11-2-10-5-10-7-9-9-8-10-5-10-1-15 4-29 13-18 8-19 7-11 4h-16l-12-7-10-10-7-11-4-9v-19l7-15h2l2-6 11-12 5-6 12-9 9-5 13-4z",
    fill: "#1C1C1C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(576,680)",
    d: "m0 0h4v2l-17 8-27 10-17 8-19 11-13 9-10 8-12 11-6 5-9 11-11 14-9 14-9 21-4 13-3 14-4 29v38l3 26 3 15 8 21 4 10 6 9 5 9 1 3h2l4 6v2h2l5 7v2l3 1 6 8 5 4 7 8 16 13 27 18 16 7 28 10 13 6v4l-8-1-14-5-9-3-18-7-8-4-14-8-19-13-14-11-18-18-13-17-7-10-9-15-8-17-5-15-5-23-2-12v-43l2-20 4-22 4-15 8-20 5-9 3-7 7-9 1-3h2v-3l5-5 16-17 7-7 11-9 7-5h2v-2l11-7 28-16 19-8 23-8z",
    fill: "#1A1A1A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(762,372)",
    d: "m0 0h34l29 4 26 7 19 8 20 11 11 7v2l4 2 12 9 10 9 8 7 6 7 7 9v3h2l2 7h2l7 14 4 4 5 10 3 7 10 23 4 20 1 18v48l-1 16-4 24-6 6-2-1 2-10h2v-14l2-22v-45l-2-15-3-21-8-21-9-21-7-10-8-14-8-10-9-10-14-13-17-13-13-9-16-8-17-7-19-6-15-3-19-2h-33l-18 2-16 4-20 7-18 8-18 11-12 9-14 11-10 9-12 10h-2l1-5 9-10 11-9 13-10 14-10 12-8 15-8 13-5 12-5 27-7z",
    fill: "#1C1C1C"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1147,811)",
    d: "m0 0 3 1 5 5 4 9 3 15 1 10v69l-1 11-8 27-8 20-6 11-13 20-18 22-13 13-11 9-18 12-16 9-17 8-29 9-26 6h-14l-16-2-2 2-5-1-8-2-13-2-19-5-8-2-16-5-8-4-9-5-21-14-18-13-13-11-5-4-10-14 1-2 12 8v2l5 2 5 5 3 2v2l3 1v2l5 2 8 7 18 13 16 10 20 8 24 7 31 7h10l5 1h12l29-6 16-5 21-7 15-8 11-6 13-9 13-10 13-12 13-16 7-9 10-16 7-12 5-11 7-20 3-12 2-19v-53l-3-25-7-22z",
    fill: "#1B1B1B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(539,126)",
    d: "m0 0h4l-1 5-8 5-23 10-15 8-48 23-3 1 6 16 10 19 8 16 4 11 3 5 4 6 4 4 5 12 8 16 8 17 10 18 4 8 2 5v3h2l3 8 4-1 7-3 16-8 10-6 8-4 22-12 8-4 12-7 8-4h5l1 4-10 7-41 20-16 8-27 15-8 5-4-1-10-19-15-28-10-22-8-16-14-27-9-16-8-16-8-17-6-12 8-4 21-10 16-9 23-11 24-12z",
    fill: "#191919"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(801,577)",
    d: "m0 0h15l27 9 28 12 11 6 20 12 16 12 14 12 12 11 5 5v3h2l7 17 8 9 4 4v2h2l4 9 3 6 1 8h2l3 18 2 17v66l-1 20-3 14-5 9-3 2 1-7 1-3 1-31 1-16v-22l-1-40-3-23-7-20h-4l-2 2-4-1 4-4h2v-9l-3-1-4-5-2-1h-9l-16 4-14 6-35 14-16 8-22 13-6 4h-3l1-3 4-2 4-6 8-5 6-3 9-5 12-7 17-7 11-4 13-4 10-4 9-1 13-2v-5l-2-1 2-2-5-7-10-8-11-9-14-12-14-10-20-12-15-8-16-7-3-2-13-4-17-6-8-3z",
    fill: "#333"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1074,1235)",
    d: "m0 0h5l9 21 5 8 9 19 8 14 6 14 4 7v3h2l6 12v3h2l6 10v3h2l8 16 5 8 1 5h2l5 10 8 15v5l-22 11-14 8-23 11-38 19-13 4v-3l5-4 16-9 9-4 12-5 15-8 14-7 18-10 8-5h2v-2l2-2-12-18-14-26-8-15-7-11-7-14-6-11-16-32-9-20-5-11-6 1-14 8-11 7-50 25-13 6h-10v-2l19-10 16-7 32-16 17-9 5-4 8-4 5-3z",
    fill: "#1B1B1B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(618,700)",
    d: "m0 0 8 6 6 5 7 8 16 15 13 10 21 13 5 2v2l6 2 5 3 7 3 4 3 5 2 12 5v2h8l4 3 5-1h10l2 3-4 2-10 2-1 1-12 1-19 7-25 13-18 11-16 11-15 13-21 21-10 15-7 13-5 16-4 10-6 25-3 18-1 13v29l-1-2h-2l-1-7-1 12h-1v-44l2-12 4-22 6-18 4-9 2-8 6-12h2v-3h2l1-4 5-9 11-12 18-18 14-11 12-9 6-4h2v-2l9-5 7-5 11-6 11-5 13-5-14-9v-2l-9-3-15-8-18-11-14-10-11-9-12-11-9-10-7-12z",
    fill: "#1D1D1D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(772,573)",
    d: "m0 0m-2 1h2v2l-49 17-21 9-19 9-17 11-26 20-15 14-13 15-6 11-6 17-6 16-3 15-4 36v56l2 16 2 25h-2l-2 7h-2l-1-12-3-16-1-2-1-9v-47l1-22 2-16 2-21 3-9 2-10 5-11 4-10 1-2h2l2-5h2v-3h2l1-4 3-7h2l2-5 11-11 8-7 10-9 17-13 7-6 6-3 13-8 15-7 8-4 13-5 14-5 21-5 10-1z",
    fill: "#1B1B1B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(320,1140)",
    d: "m0 0h24l13 5 9 8v2h2l8 16 2 8v23l-3 8-6 9-8 7-7 4-11 3-11 1h-9l-11-2-11-6-8-9-6-11-2-8v-23l4-12 3-6h2l2-5 11-8zm6 6-11 4-9 7-8 10-3 6-1 5 2-9 5-10 5-6 6-4-2-1-6 4-6 6-6 16-1 6v15l3 10 2 1-1-4h2l2 6h2l2 4 5 5 9 6 9 3 16 1 11-4 9-7 6-7 3-7 1-5-1-14-5-14-7-11-7-7-12-5z",
    fill: "#313131"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(967,480)",
    d: "m0 0h32l23 5 13 4 9 4 7 3v2l9 3 9 6 12 9 11 9 12 11 12 12 6 7 12 17 1 4h2l6 11 8 17 8 23 4 21 1 13v50l-1 12h-1l-1-7-3 17-1 2h-2l3-42v-17l-1-18-4-25-7-21-12-26-10-16-11-14-12-14-13-12-10-8-12-9-15-9-17-8-13-5-29-6v-2l-25-2z",
    fill: "#1C1C1C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1267,359)",
    d: "m0 0h11l9 4 10 7 7 7 9 13 3 8v10l-2-2-1-8-5 2-2-2h-7v-2l-10-1-13-8-3-4-2-5h-4l-3 6-3 5h-2v2l-8 5-15 3-4-8-1-5 4-6 8-7 5-6 14-7z",
    fill: "#D5D5D5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(766,800)",
    d: "m0 0 4 4 3 4-1 5-1 3-3 3-3 4h-2v88l4 40 2 13-4-1-6-15-1-1-2-28-1-84-6 4-23 14-13 8-18 10-17 8-19 8-12 5-8 3-3-1 6-5 12-6 13-5 9-5 7-3 20-11 6-4h3v-2l12-7 14-10 11-9 8-7 4-5 6-4 1-4h-3v-6z",
    fill: "#2E2E2E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(946,705)",
    d: "m0 0h3v2h-2l-2 4-15 16-11 9-13 10-17 12-25 14-19 10-6 4-7 1v2l6 1 11 4 13 5 17 7 4 2v2l5 1v2h3v2l4 1v2l6 2 8 7 4 2v2l4 2 15 14 8 9 7 9 3 4-1 2-5-5-6-4-7-8-8-7-7-7-19-14-5-4-7-4-8-5-11-6-10-4-13-6-15-6-37-4 1-2-13-2 2-3 11 1 5 1h28l12-2 1-2 7-3 10-4 10-6 13-8h3v-2l9-5 7-6 11-8 10-9 5-3 11-10 3-4h2v-2z",
    fill: "#1E1E1E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(785,580)",
    d: "m0 0 4 4 4 6 4 4v2h2l5 10 5 14 2 17 2 33v65l7-4 13-8 7-4h3l-5 6-3 1-1 4-4 3h-3v2l-3 1-5 5-16 15-9 8-9 6-7 6-8 1 2-4 10-5h3l2-4 4-5 5-4 5-10 3-4v-49l-3-69-1-14-2-6h-2l-4-7-3-3-3 7h-3l1-5h2v-10l-3-4z",
    fill: "#5B5B5B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(576,680)",
    d: "m0 0h4v2l-17 8-27 10-17 8-19 11-13 9-10 8-12 11-6 5-9 11-11 14-9 14-9 21-4 13-3 14-4 29v38l1 16-2-3-1-10-2-1-1-31-1 39h-1v-43l2-20 4-22 4-15 8-20 5-9 3-7 7-9 1-3h2v-3l5-5 16-17 7-7 11-9 7-5h2v-2l11-7 28-16 19-8 23-8z",
    fill: "#1C1C1C"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1262,352)",
    d: "m0 0h20l13 5 10 8 5 6v2h2l6 12 3 11v16l-5 12-9 11-11 7-14 5-6 1h-16l-11-3-8-4-5-5v-2h-2l-6-10-5-14-2-8v-10l4-11 5-9h2l2-5 6-5h2v-2l8-5zm-6 6-11 6-9 8-7 10-2 2-2 5v9l2 12 6 15 5 7h2l1 3 7 4 11 3 9 1h10l13-4 10-6 7-6 6-9 2-5v-15l-4-10-10-13-7-7-11-7-6-2h-11l-10 3-12 7-6 4 8-7 10-6 2-2z",
    fill: "#555"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 260)",
    d: "m0 0h4v27l5 12 7 11 9 10 9 8 11 7 14 5 13 2 11-1 15-6v-2l7-6 4-5 1-2h2v-3h2l1-4 2-3-1-8-5-12-6-11 1-5 3 1 5 6 2 1v3l3 1 4 8 1 3v14l-4 9-6 9-8 8-12 7-14 4h-19l-11-4-12-6-13-9-15-15-9-14-6-18-1-6v-9z",
    fill: "#1C1C1C"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(163,839)",
    d: "m0 0h80l28 1v2h11v3l-7 2-189 1-1-8z",
    fill: "#212121"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(845,81)",
    d: "m0 0 12 3-3 3-3-1 3 3-5 25-11 74-8 47-3-6-3 13h-3l1-18 8-49 3-17 8-52z",
    fill: "#2E2E2E"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(784,788)",
    d: "m0 0h2v2l-7 5 5 5 9 7 7 5v2l4 1 5 3v2l3 1 7 8 7 6v2l4 1v2l4 1 3 2v2l2 1-9-1h-3l-14-7v50l-1 29-2 21-4 12-4 6-5 2 1-6 3-5 2-15 1-16 1-55 1-20 3-4-6-10-1-4-3-1-7-10-3-3-5-4-6-7-7-2 4-4z",
    fill: "#5B5B5B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(271,841)",
    d: "m0 0h22l2 1-2 5-14 11-14 8-26 17-15 9-25 14-29 16-22 13-15 10-9 5v2h-5v3h-9l-1-2 8-8 11-6 21-12 15-9 12-7 11-6 17-10 9-5 7-4 9-5 15-9h2v-2l9-5 15-10 11-7 2-2-1-3-11-1z",
    fill: "#191919"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1452,522)",
    d: "m0 0h4l-1 6-9 6-31 15-19 10-26 14-19 10-47 23-14 8-14 7h-6l6-7 13-7 11-6 19-10 21-10 9-5 11-6 16-8 10-6 16-8 18-10 19-10 10-5z",
    fill: "#1A1A1A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(348,259)",
    d: "m0 0 15 2 14 5 4 3-1 4-5 4-4-2-6-4-14-5-9 1-12 3-12 6-10 8-7 7-9 13-6 11-1 4v12l6 14 8 10 10 7 2 4 3 1v2l3 1h11l-1 3h-16l-12-7-10-10-7-11-4-9v-19l7-15h2l2-6 11-12 5-6 12-9 9-5 13-4z",
    fill: "#181818"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(702,1313)",
    d: "m0 0h41l35 2 5 1-2 27-2 21-2 7-4-1v-16l1-2h-2l2-6v-24l-37-2h-31l-15 3-10 4-6 5-8 10-9 14-5 1 2-13 7-9 5-5 11-10 12-5z",
    fill: "#1F1F1F"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1196,1139)",
    d: "m0 0h34l11 2v4l-3 2h-22l-3-1h-16l-15 4-10 5-11 8-3 1-2 4-9 13-4 8-4 11v14l7 13 1 3h2l2 5 4 2 4 5 1 4 3 1v2l7 1 1 2h-2v2l-9-1-4-2v-2l-4-2-7-6-7-11-5-11-1-3v-14l3-11 8-16 11-13 9-8 14-9 13-5z",
    fill: "#1D1D1D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1503,734)",
    d: "m0 0h5v6l-3 3h-177v-1l5-1-14-1v-1l13-1 62-2z",
    fill: "#191919"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(136,949)",
    d: "m0 0h55l50 2 10 1 25 1 24 2 6 1 17 1v1l-8 1 2 2-3 1-24-1-28-2-18-1-67-2-58-1v-3z",
    fill: "#252525"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(747,78)",
    d: "m0 0h2l-1 7-27 4-61 9-20 4v9l-1 5v7h-2v2h2v18h2l2 9v11l2-1v-6l2 2 1 10-2 6v5h-2l-1-8 1-2h-3l-5-28-3-15-3-23-2-4 8-3 35-6 21-4 19-3 21-3z",
    fill: "#1B1B1B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(849,81)",
    d: "m0 0 27 1 21 3 15 4 12 5 14 9 12 12 7 11 6 15 3 12-1 7-5-5h-2l-5-17-8-16-11-12-11-8-15-7-18-4-9-1-29-1-1-3 5-1-8-2z",
    fill: "#191919"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(965,912)",
    d: "m0 0h8l6 8 2 1 3 7 3 18 1 13v60l-2 16-4 16-6 9-8 9-1-3 8-15 4-16 2-21v-44l-2-22-3-16-4-13-2-3-6-1h-9l3-2z",
    fill: "#353535"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(653,1347)",
    d: "m0 0 2 3-1 6 4 1-4 8-7 23-1 7v33l2 17 2 8 2 6-4-2-4-4-1 2h-2l-6-17-1-6v-26l4-22 6-19h2l1-6z",
    fill: "#303030"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(627,911)",
    d: "m0 0 2 4v2h2l7 8 13 12 17 13 14 9 23 12 19 7 26 6 15 4v-4l4 2 1 1h8l4-4 2-4 1 3-3 5-2 3-8 1-26-1-16-3-11-4-9-3-14-6-12-7-11-6-12-8-11-9-8-6-17-17-1-4h-2v-3z",
    fill: "#1B1B1B"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(794,1013)",
    d: "m0 0 9 5 4 3v2l5 2 5 5 3 2v2l3 1v2l5 2 8 7 18 13 16 10 20 8 24 7 35 8-1 4-4 1-10-3-13-2-19-5-8-2-16-5-8-4-9-5-21-14-18-13-13-11-5-4-10-14z",
    fill: "#191919"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(598,502)",
    d: "m0 0h2l-2 6-7 14-2 9-1 12-1 3v56l4 44v8l-6-1-3-14-2-22v-60l1-19 3-20 5-9 5-5z",
    fill: "#393939"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1090,148)",
    d: "m0 0h18l18 6 14 8 11 9 8 9 6 10 5 13 2 15v10l-5 5-5 1-1-5 3-8v-7l-5-17-6-12-9-10-10-8-12-7-17-5h-8l-7 1h-13l2-4 3-2z",
    fill: "#1A1A1A"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(661,248)",
    d: "m0 0h2l1 8-1 2h2l-1 4 3 4 1 13h13l20-3 37-6 25-5 14-4h6v5l-7 3-37 8-64 10-9 2h-8l4-5-1-11-2-11v-10z",
    fill: "#1A1A1A"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(801,577)",
    d: "m0 0h15l27 9 28 12 11 6 20 12 16 12 14 12 12 11 5 5 1 5h-3l-22-18-14-12-14-10-20-12-15-8-16-7-3-2-13-4-17-6-8-3z",
    fill: "#1D1D1D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(441,804)",
    d: "m0 0 5 2 10 9 7 8 9 9 19 14 20 12 21 11 20 9 16 6 10 5 1 5-8-1-10-5-9-3-15-6-16-8-11-6-8-4-18-12-17-13-15-15-8-11v-3h-2z",
    fill: "#1B1B1B"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(971,497)",
    d: "m0 0 3 4 9 21 4 20 1 18v48l-1 16-4 24-6 6-2-1 2-10h2v-14l2-22v-45l-2-15-3-21-1-6-1-11-2-1z",
    fill: "#525252"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(942,915)",
    d: "m0 0h7v3l-10 6-5 5h-2l-1 3-8 7-12 10-18 12-15 9-27 12-20 6-18 3h-16l-8-1v-1l13-2 22-4 15-3 17-6 16-8 11-6 15-10 14-10 10-9 6-5 5-6z",
    fill: "#1C1C1C"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(980,677)",
    d: "m0 0 9 1 11 5 35 12 19 10 11 6 14 9 13 10 16 13 8 8 5 8v2h2v3h2l1 4-4-2-15-14v-2l-3-1v-2l-4-2-9-8-19-14-11-7-7-4-15-8-21-9-13-4-9-4v-2l-4-1-12-6z",
    fill: "#1C1C1C"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(298,1154)",
    d: "m0 0 2 3-6 13-2 10v15l3 9v-2h2l2 3v3h2l4 5 8 7 9 4 14 2 3 3 1 2 3 2-11 1h-9l-11-2-11-6-8-9-6-11-2-8v-23l4-12 3-6h3z",
    fill: "#555"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(926,1298)",
    d: "m0 0h9l1 2-1 2h-2v2l2 1v16l1 12-4-2-2-8-1-18-39 7-39 8-24 4h-9l-1-1v-5l28-4 27-5 27-6 17-3z",
    fill: "#1C1C1C"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(940,476)",
    d: "m0 0h10v1l-14 2-12 5-3 2-16 3-21 7-21 10-11 7-18 13-15 14-11 12-3 4h-5l1-4 9-11 9-10 11-9 12-9 11-8 12-6 10-6 18-8 21-5 14-3z",
    fill: "#1B1B1B"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(621,675)",
    d: "m0 0 9 1 26 9 20 7 12 5 19 10 9 5 9 7 3 1v2l7 2 7 6 6 3v2l4 2 1 4 4 2h2l3 1v2l3 1 2 7v7l-5-3-9-13-17-12-13-8-10-6-17-11-16-8-16-6-14-6-14-7-15-5z",
    fill: "#222"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(765,1013)",
    d: "m0 0h4l-1 6-6 9-7 8-13 10-9 7-20 13-20 11-47 17h-7l2-1v-2l10-5 12-4 8-3 26-11 6-4 9-5 14-9 16-12 12-11 8-9z",
    fill: "#1D1D1D"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(966,1472)",
    d: "m0 0h2l3 9 1 7-21 5-41 7-30 5-25 5h-4v-5l7-2 24-5 52-9 29-5-1-6 2-4z",
    fill: "#1E1E1E"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1306,825)",
    d: "m0 0h8v1l-5 1 1 7 2 2-1 15-3 20-5 38-4 25-3 6-8 1 3-9 3-17 6-38 4-35z",
    fill: "#393939"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(829,844)",
    d: "m0 0h5l9 4 17 10 17 9 16 6 33 11 21 3 2 1h7l2-1h8l-1 2h-4v2l-10 1-4 1-22-3-6-2-10-2-9-3-20-7-14-7-9-5-13-8-7-4-8-7z",
    fill: "#1D1D1D"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(436,1358)",
    d: "m0 0 5 1 1 4-1 9-2 10 3 11 4 8 4 6 9 10 9 8 10 6v2l8 2v1l13 2 2 2h-14l-13-4-14-9-10-9-8-9-6-10-3-9-3-12v-16l3-3z",
    fill: "#191919"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(618,700)",
    d: "m0 0 8 6 6 5 7 8 16 15 13 10 21 13 5 2v2l6 2 5 3 9 6 1 2 4 1v2l5 2 1 3-7-1-5-3v-2l-9-3-15-8-18-11-14-10-11-9-12-11-9-10-7-12z",
    fill: "#1E1E1E"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(642,1453)",
    d: "m0 0 5 1 1 3 5 2 6 10 9 10 10 8 11 5 24 7 19 5 11 1h3v-2l3 1 5 1 1 3-2 2h-17l-25-5-14-3-9-4-11-4-13-9-12-12-7-10-3-6z",
    fill: "#1A1A1A"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(940,1120)",
    d: "m0 0h5l-2 6-11 10-8 7-8 8-14 10-21 13-18 8-19 7-1-3-2-2 16-6 18-8 16-9 14-10 14-12 13-14z",
    fill: "#1A1A1A"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(952,1395)",
    d: "m0 0 2 3 9 49 4 20-1 8h-2l-2 4-2-2-5-18-3-12-3-17-2-16 1-8 2-1z",
    fill: "#343434"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(199,643)",
    d: "m0 0h6l1 2-5 42-3 24-4 22v6h-8l1-2h2l-2-3v-9l9-57 2-24z",
    fill: "#353535"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1249,1061)",
    d: "m0 0h1l2 11 5 12 9 11 8 6 10 4 11 3 11-1 10-1-5 5-11 5-15-1-12-5-13-9-7-7-6-12-3-16 2-4z",
    fill: "#191919"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1262,352)",
    d: "m0 0h20l13 5 10 8 5 6v2h2l6 12 3 11v16l-5 12-9 11-11 7-14 5h-15v-3l16-3 12-5 11-8 7-10 2-5v-15l-2-9-6-18-4-2-8-7-10-4-9-2v-1l-14-1z",
    fill: "#333"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(946,705)",
    d: "m0 0h3v2h-2l-2 4-15 16-11 9-13 10-17 12-25 14-7 4h-5l1-4 11-6 9-6 5-3h3v-2l9-5 7-6 11-8 10-9 5-3 11-10 3-4h2v-2z",
    fill: "#1F1F1F"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(768,607)",
    d: "m0 0h2l-2 10-2 16-2 7-1 9-1 21-1 59h-4l-1-10v-63l1-18 1-5 3-7 3-14z",
    fill: "#2D2D2D"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(742,836)",
    d: "m0 0 1 2 6-2-1 4-14 8-19 12-22 12-15 7-19 8-12 5-8 3-3-1 6-5 12-6 13-5 9-5 7-3 20-11 6-4h3v-2l7-4 7-2 8-4 5-4 3-1z",
    fill: "#242424"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(746,169)",
    d: "m0 0h5v6l-10 3-62 10-23 3h-4l-2 3v-2l-2-1 2-2h3v-3l16-3 39-7 17-3z",
    fill: "#1F1F1F"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1243,421)",
    d: "m0 0 6 1v2l5 2 9 3 8 1 4 2h7l11-6 8-1 2 3-1 4-9 6-10 4-5 1h-10l-18-8-2-4-2-1-1-3h-2z",
    fill: "#D4D4D4"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1401,846)",
    d: "m0 0h2l2 13v11l-3 37-2 32-1 2h-7l-2-2 2-9 3-24 2-23 1-18z",
    fill: "#1C1C1C"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(766,800)",
    d: "m0 0 4 4 3 4-1 5-1 3-3 3-3 4h-2l-1 38-4-1-2 1-1-26-6 3v-2l-6 2-7 4-1 2-9 4-5 1 4-4 12-8 13-11 7-6 4-5 6-4 1-4h-3v-6z",
    fill: "#343434"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(404,648)",
    d: "m0 0h1l-1 43 3-3 3 2 1 17 5 37 4 12v2h-7l-2-1-3-9-2-14-2-25-1-6v-48z",
    fill: "#3A3A3A"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(769,1362)",
    d: "m0 0 2 4-1 13h-2v15l-4 26-3 15-1 12-3 17-2 18v7l5 2-1 9-3 10-3-1v-3l-5-1-2-2v2h-2l2-4 2-6 2-7 5-36 2-11 1-12 1-3 2-16z",
    fill: "#5B5B5B"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1156,622)",
    d: "m0 0 2 3 4 16 2 20v50l-1 12h-1l-1-7-3 17-1 2h-2l3-42v-17l-1-18-1-11 2 1v-12l-2 3-1-5v-11z",
    fill: "#383838"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(784,788)",
    d: "m0 0h2v2l-7 5 5 5 9 7 7 5v2l4 1 5 3v2l3 1 7 8 7 6v2l4 1v2l4 1 3 2v2l2 1-9-1h-3l-11-6v-2h-4v-2h-4l-6-9v-3l-3-1-7-10-3-3-5-4-6-7-7-2 4-4z",
    fill: "#393939"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(580,762)",
    d: "m0 0h1v49h2l1-2 1-39h1l1 52 2 16 2 25h-2l-2 7h-2l-1-12-3-16-1-2-1-9v-47z",
    fill: "#5E5E5E"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(930,679)",
    d: "m0 0 2 1-4 4-12 5-35 14-16 8-22 13-6 4h-3l1-3 4-2 4-6 8-5 6-3 9-5 12-7 17-7 11-4 13-4 1-1z",
    fill: "#242424"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(923,1398)",
    d: "m0 0h12l-1 2h8l-1 2-25 4-32 6-29 6h-7l1-5 7-3 20-3 41-8z",
    fill: "#1D1D1D"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1103,1330)",
    d: "m0 0h10v2l-13 7-9 6-40 20-13 6-4 1h-8l5-5 7-4 13-5 17-9 9-4 16-9 9-5z",
    fill: "#1E1E1E"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(640,109)",
    d: "m0 0h1l11 56 3 21h-2l-1 2-2-2v2h-2v2l-3 1-3-16v-6h2v10h2l-1-6 2-7-1-4-1 2-3-1v-12l-1-2v-6h-2l-1-16 1-2h-2l-1-3h2v-10z",
    fill: "#555"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(589,706)",
    d: "m0 0 2 4-1 11 1 9-4 36-1 4-1 39-1 6-1-4h-2v-54l3-32 3-9z",
    fill: "#383838"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1256,353)",
    d: "m0 0 25 1v2l10 3 9 6 6 5 3 2 1 7 4 8-1 3-4-5-9-11-8-7-8-5-6-2h-11l-10 3-12 7-5 4-2-1 9-8 9-6-10 5h-3l-1-4 8-5z",
    fill: "#4F4F4F"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(772,785)",
    d: "m0 0h15l-5 5-10 5v1l7 2 8 9 2 2-7 3h-4l1-3-6 5-2-1 1-5-5-7h-1v5l3 1-1 4-5 4-1-4 1-3v-11l-11-7-4-1 2-1 15-2z",
    fill: "#B9B9B9"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1493,876)",
    d: "m0 0h1v10l-1 4v16l-9 52-3 9-3 2h-4l3-12 8-41 5-37z",
    fill: "#252525"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(569,212)",
    d: "m0 0h5l-1 4-5 4-33 16-28 13-15 6h-5l5-4h3v-2l16-8 17-8 13-8 19-9z",
    fill: "#1D1D1D"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1147,811)",
    d: "m0 0 3 1 5 5 4 9 3 15 1 10v20l-1 39-2 1-1-5h-1l-1-45-3-25-7-22z",
    fill: "#1F1F1F"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(413,816)",
    d: "m0 0 3 3 1 6-3 14-4 29v38l1 16-2-3-1-10-2-1-1-31-1 39h-1v-43l2-20 4-22z",
    fill: "#3D3D3D"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1077,152)",
    d: "m0 0 2 1v2l7 1-4 3-9 6-8 9-7 14h-2l-1 2h-2l2 14h2l3 7v4l-2 3-6-10-4-13 1-6 3-8 6-11 8-10 3-1v-2z",
    fill: "#2C2C2C"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1364,1031)",
    d: "m0 0h3l-1 4-10 26-10 18-6 12-1 7v3l-6 2v-4l-2-1-1 2-14 7-3-2 11-5 5-4 5-9 10-16 5-12 8-16 5-9z",
    fill: "#1E1E1E"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(960,154)",
    d: "m0 0 3 3 1 2 3-1v20l-3 22-1 5-1-2-3 1-3 6-2 8-3 3-2 4-1-2 4-13 3-10 3-21 1-24z",
    fill: "#323232"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(986,979)",
    d: "m0 0h1v51l-4 18-5 10-11 11 1-5 7-13 4-16 3-31 1-24h1l1 18z",
    fill: "#202020"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(298,642)",
    d: "m0 0h5v11l-4 34-2-4-3 16-1 1v11l-1 9-2 1-2-1 1-10 4-32 2-24z",
    fill: "#373737"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1137,1213)",
    d: "m0 0 4 4 5 10 1 3h2l2 5 4 2 4 5 1 4 3 1v2l7 1 1 2h-2v2l-9-1-4-2v-2l-4-2-7-6-7-11-4-8v-8l3 1z",
    fill: "#1C1C1C"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(755,666)",
    d: "m0 0h1l1 63h4v-59h1v69l3 5 6 15 6 9-4 2-4-1-1-3-2-1-2-6 2 1-1-11-5-5h-3l-4-3v-3h2z",
    fill: "#656565"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(838,1185)",
    d: "m0 0h5l1 2-2 3-23 5-7 1h-20l-1-1-23-1-14-2-2-2 14 1h31l27-3z",
    fill: "#202020"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(639,103)",
    d: "m0 0h1v8l-1 5v7h-2v2h2v18h2l2 9v11l2-1v-6l2 2 1 10-2 6v5h-2l-1-8 1-2h-3l-5-28-3-15-1-17 2-2 2-3 2 1z",
    fill: "#383838"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(411,615)",
    d: "m0 0 1 4v10l-1 1v10l-1 8-1 44-3-3v2h-2v-35l2-24z",
    fill: "#252525"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(340,1167)",
    d: "m0 0 4 1 6 12 2 10v9l-2 2-2-6-2-1v-2l-4 1-3 12h-2v-18l2-15z",
    fill: "#9F9F9F"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(119,843)",
    d: "m0 0h27v1l10 1 100 1v1l-170 1v-3l16-1h16z",
    fill: "#3D3D3D"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(707,767)",
    d: "m0 0 5 2 4 3 5 2 12 5v2h8l4 3 5-1h10l2 3-4 2-10 2-1 1h-10l-6-2h-6l2-2-6-4 4-1-4-4-2-1v-2l-5-1v-2l-5-2z",
    fill: "#5E5E5E"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(984,942)",
    d: "m0 0 1 4h2l1 13v60h-1l-1-21-1 14h-1l-1-8h-1l-1-34-1-18 2 2 1-2z",
    fill: "#3A3A3A"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(845,775)",
    d: "m0 0 2 1-5 5-15 6v3h-10l-26-3 1-2-13-2 2-3 11 1 5 1h28l12-2 1-2z",
    fill: "#505050"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(971,497)",
    d: "m0 0 3 4 9 21 1 5 1 17v15l-2 3-1-1-2-10-4-25-1-6-1-11-2-1z",
    fill: "#3A3A3A"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(583,941)",
    d: "m0 0 2 3v16h1l-1 18v29l-1-2h-2l-1-7-1 12h-1v-44l2-12z",
    fill: "#363636"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(983,589)",
    d: "m0 0h3l1 2-1 37-3 20-6 6-2-1 2-10h2v-14l1-9h2z",
    fill: "#3C3C3C"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(324,1165)",
    d: "m0 0h5l2 2-1 20v19l1 4-4-1-2-3-1-28-4 1-3 7-1-4 4-13z",
    fill: "#9E9E9E"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(729,788)",
    d: "m0 0 6 1 2 2-21 8-19 10h-2v-4l-2 1-2-2 14-8 12-5z",
    fill: "#1F1F1F"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(610,666)",
    d: "m0 0h1v7l-5 9-6 17-6 16-2 9h-2l-1-4 1-10 1-8 6-15 2-4h2l2-5h2v-3h2l1-4z",
    fill: "#202020"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1503,734)",
    d: "m0 0h5v6l-1 2h-53l1-2 12-2 5 1 3-1h28l-48-1v-1l36-1z",
    fill: "#131313"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(808,620)",
    d: "m0 0h1l2 17 2 33 1 66-3 2-1-12v-67l-1-12-1-2z",
    fill: "#9F9F9F"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(974,699)",
    d: "m0 0 3 3 3 9v3h2l3 18 2 17v66h-1l-1-30-1-13-1-5 1-6-1-21-2-9-1-5 1-4h-2v-8h-3l1-5-2-2z",
    fill: "#7F7F7F"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(755,1464)",
    d: "m0 0h1v11l-1 14 5 2-1 9-3 10-3-1v-3l-5-1-2-2v2h-2l2-4 2-6 2-7 3-21z",
    fill: "#555"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(261,953)",
    d: "m0 0h15l24 2 6 1 17 1v1l-8 1 2 2-3 1-24-1-28-2v-1l6-1 4-2-11-1z",
    fill: "#363636"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(370,1210)",
    d: "m0 0h4l-2 5-7 8-11 7-9 2h-10l3-2h-5l4-2 9-3 10-5 10-9 1 2z",
    fill: "#1B1B1B"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1219,1307)",
    d: "m0 0 7 1 6 4 11 4h18l-3 2-13 1-4 1 6 2v1l-15 1-6-3-4-5-3-6z",
    fill: "#3C3C3C"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(843,93)",
    d: "m0 0h1l1 10-1 8-1 5-1 6-2 3-4 27v8l-1 4-1 10-2 3v11l-2 11-1 2h-2l1 2v8l-3 6h-1v-7l6-35 3-17 8-52z",
    fill: "#5B5B5B"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(954,1447)",
    d: "m0 0 4 1 3 2v-3h2l4 20-1 8h-2l-2 4-2-2-5-18-1-5z",
    fill: "#333"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1441,735)",
    d: "m0 0h50v1l13 1-1 2h-29l-3 1-4-1-15 2-11-1v-1h5v-2h-52v-1z",
    fill: "#484848"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1278,356)",
    d: "m0 0 11 2 10 6 7 6 3 2 1 7 4 8-1 3-4-5-9-11-8-7-8-5-6-4z",
    fill: "#4F4F4F"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1061,217)",
    d: "m0 0h2l5 5 9 11 7 9 2 2-1 3 3 4 9 11h-3l-12-13-7-8-12-15-3-5z",
    fill: "#141414"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1493,876)",
    d: "m0 0h1v10l-1 4v16l-1-2h-2v10l-3 12-2 12-4 2 2-15 3-16 4-30z",
    fill: "#363636"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(288,1186)",
    d: "m0 0h1l1 12 5 12 4 6 7 7 2 1v2l5 2 6 2v2h-7l-11-6-8-9-6-11-1-5v-10h1z",
    fill: "#2D2D2D"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1055,187)",
    d: "m0 0 3 1 1 9 7 15 5 8v2l3 1-1 3-4-2-3-1-3-4-1 1h-3v-5-4l-2-3v-4h-2l-2-7v-7h2z",
    fill: "#383838"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(849,773)",
    d: "m0 0h4v2l2 2-15 8-5 2h-3v2l6 1 11 4 10 4v1l-10 1-22-10v-2l-2-2 13-4 7-4 2-4z",
    fill: "#343434"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1309,424)",
    d: "m0 0h2l-1 4 2-1-2 5-10 8-12 5-6 2h-15v-3l16-3 12-5 11-8z",
    fill: "#313131"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(768,607)",
    d: "m0 0h2l-2 10-2 16-2 7-1 9-2-4-2 2-1 6h-1v-19l2-2 4-15 2-6z",
    fill: "#414141"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1304,842)",
    d: "m0 0 4 1-1 5-3 30-2 9-1 11-1 2h-2v12h-1l-1 5h-2l6-40z",
    fill: "#5B5B5B"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(199,643)",
    d: "m0 0h6l1 2-4 35-2 5-2 1v-10l2-15-2 1v-18z",
    fill: "#191919"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(500,291)",
    d: "m0 0 3 4 7 14 9 17-1 4-4-2-5-8-6-12-2-6-2-7z",
    fill: "#383838"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(950,659)",
    d: "m0 0 2 2 6 15 8 9 4 4-1 2-2-1-2 2-1-6-3-1-4-5-2-1h-9l-15 3-1-2-5 1 1-2 12-2 13-2v-5l-2-1 2-2-2-3z",
    fill: "#4C4C4C"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(642,1371)",
    d: "m0 0 1 4-1 10h-2l-2 23v36l-2-2-2-10v-26l4-22z",
    fill: "#686868"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(772,785)",
    d: "m0 0h15l-5 5-10 3h-2l-1 3-4-1-9-5 1-2z",
    fill: "#F0F0F0"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(787,762)",
    d: "m0 0 2 1-4 5-11 5h-2l-1 3 3 2-7 2-4 2 10 2-1 2-14 2 3-3-4-1h-7l-4-1-1 2-4-4h16l6-3h2v-2l5-2-1-5 7-1-1-3 7 1z",
    fill: "#9D9D9D"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(320,1140)",
    d: "m0 0h7l3 3-13 4-11 4-5 5h-4l-4 3 2-5 5-5 9-6z",
    fill: "#474747"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1074,225)",
    d: "m0 0 5 5 16 17 5 7 5 5 7 8 3 5-1 2-5-4-2-5-4-2-1-5-2 3-2-4-6-8-5-5v-2l-3-1-8-10-2-3z",
    fill: "#5A5A5A"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1395,906)",
    d: "m0 0h1l1 12v3 4l3 1v13l-1 2h-7l-2-2 2-9z",
    fill: "#373737"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(298,642)",
    d: "m0 0h5v11l-2 17-2 4h-1l-1-9-1-1v-15z",
    fill: "#1B1B1B"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1162,851)",
    d: "m0 0h1v20l-1 39-2 1-1-5h-1v-36h1v-10l2-1z",
    fill: "#393939"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1401,886)",
    d: "m0 0h1v21l-1 14-1 5-3-1-2-3 1-8v-11l1-7 2 1z",
    fill: "#151515"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(114,618)",
    d: "m0 0h7l-1 5-5 22-3 3-1-2 1-4h-2v-3l2-1v-15z",
    fill: "#161616"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(310,1148)",
    d: "m0 0 2 1-6 4-7 9-5 13 1 3 2 19 2 8-2-1v-2h-2l1 4-3-3-2-8v-15l3-12 5-11 7-7z",
    fill: "#9F9F9F"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(784,788)",
    d: "m0 0h2v2l-7 5 5 5 9 7 7 5v2l4 1 2 2-6-1-4-2-1 3-4-7-6-4-7-8-7-2 4-4z",
    fill: "#4B4B4B"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1272,616)",
    d: "m0 0 2 1-3 3h6v2h10l7 1 19 1v1l-22 2v1l-10-1-9-2-5-2v-3z",
    fill: "#333"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(957,1419)",
    d: "m0 0h1l4 23-1 8-4-2-3-1-1 2-1-7 3 3 1-2-2-1 2-21z",
    fill: "#414141"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(582,770)",
    d: "m0 0h1l1 10h1v29l-1 6-1-4h-2v-40z",
    fill: "#2B2B2B"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(191,700)",
    d: "m0 0h1l1 12-2 4 1 8 2 4v11h-8l1-2h2l-2-3v-9z",
    fill: "#595959"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(111,627)",
    d: "m0 0h1l1 11-3 1v3h2v6l-2 7-2 17-3 4-1-1v-10z",
    fill: "#373737"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(807,924)",
    d: "m0 0 3 3-1 14-4 11-5 5-3 1 1-6 3-5 3-8 2-7 1-3h-2v-3h2z",
    fill: "#313131"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(750,826)",
    d: "m0 0 1 2-4 5 6-2 3-3h2l-2 5-3 1v2l-4 2v-2l-6 2-7 4-1 2-9 4-5 1 4-4 12-8z",
    fill: "#636363"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(802,758)",
    d: "m0 0 2 3-2 5-2 2v4l4 4-1 3-8-2-6-2 1-3 3-2 2-6z",
    fill: "#D4D4D4"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(722,1502)",
    d: "m0 0 16 3h8v-2l3 1 5 1 1 3-2 2h-17l-9-2-1-2-4-2z",
    fill: "#3F3F3F"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1147,811)",
    d: "m0 0 3 1 5 5 4 9 1 8h-2l-2 3-2-1-7-22z",
    fill: "#292929"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1306,737)",
    d: "m0 0 26 1 2 4-6 1h-31l1-3v2l5-1v-3z",
    fill: "#3D3D3D"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,195)",
    d: "m0 0 3 4 11 22 1 5h-3l-4-6v-2h-2v-3h-2l-3-8-2-5z",
    fill: "#3B3B3B"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(966,689)",
    d: "m0 0 6 2 4 16 2 2-2 5h-2l-6-16h-4l-2 2-4-1 4-4h2z",
    fill: "#3E3E3E"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(979,756)",
    d: "m0 0 2 4v64l-1 2-1 15h-1v-22l1-16z",
    fill: "#7F7F7F"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(750,788)",
    d: "m0 0h7v2l8 4 4 1 3-3 3 1-3 3 7 2-2 1-8-1-1 3h-2v5l3 1-1 4-5 4-1-4 1-3v-11l-11-7-4-1z",
    fill: "#9D9D9D"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(581,997)",
    d: "m0 0h1v8h2l1 2v19l-1 7h-2l-2-11v-24z",
    fill: "#141414"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(598,502)",
    d: "m0 0h2l-2 6-8 16h-2l-2-4 1-8 5-7z",
    fill: "#202020"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(661,248)",
    d: "m0 0h2l1 8-1 2h2l-1 4 3 4 1 10-2-1v-5l-2 4-3-1-2-11v-10z",
    fill: "#141414"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(664,879)",
    d: "m0 0h2l-1 3-2 2-4 3-12 5-8 3-3-1 6-5 12-6z",
    fill: "#2E2E2E"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(792,796)",
    d: "m0 0h5l3 9 1 6 5 5-6-2-5-5-10-7-4-5 5 2 3 3 4 1-2-3z",
    fill: "#D7D7D7"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(766,800)",
    d: "m0 0 4 4 3 4-1 5-1 3-6 6v-3h-4l-5 5-3-1 5-5 10-8v-3h-3v-6z",
    fill: "#393939"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1048,191)",
    d: "m0 0 5 1 2 12h2l3 7v4l-2 3-6-10-4-13z",
    fill: "#232323"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(316,1148)",
    d: "m0 0 4 1-8 4-4 4h-2l-2 4-6 8-3 9-1 19h-1v-22l5-13 8-10 4-1z",
    fill: "#505050"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(644,1404)",
    d: "m0 0h1l1 24 2 17v6l-2-3v-2h-2l-2-9 1-30z",
    fill: "#6D6D6D"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(794,1013)",
    d: "m0 0 9 5 4 3v2l5 2 5 5 3 2v2l3 1v2l5 2 6 5-2 2-3-3-5-3-10-9-8-7-7-4-5-5z",
    fill: "#3F3F3F"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(983,980)",
    d: "m0 0h1l1 39-2 14-3 1v-13l2-17z",
    fill: "#2B2B2B"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1268,356)",
    d: "m0 0h7l9 3v1h-17l-10 3-12 7-5 4-2-1 9-8 10-6z",
    fill: "#333"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(742,836)",
    d: "m0 0 1 2 6-2-1 4-14 8-5 2-7 1-4-1 12-5 6-4 4-3h2z",
    fill: "#313131"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(796,814)",
    d: "m0 0 4 1v2l5 2 6 11 2 3-1 2h-4l-6-9v-3l-3-1-3-4z",
    fill: "#1E1E1E"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1492,859)",
    d: "m0 0h1l1 10 3 2v9l-3 20-2 2v-12l1-6v-7l-2 1z",
    fill: "#1B1B1B"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(800,816)",
    d: "m0 0 9 2v2l3 1 7 8v3l-6 1-6-8-2-5z",
    fill: "#353535"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(763,741)",
    d: "m0 0 2 3 6 15 6 9-4 2-4-1-1-3-2-1-2-6 2 1-1-11-3-3z",
    fill: "#6C6C6C"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(351,1223)",
    d: "m0 0 4 2v2l2 1-3 2-9 2h-10l3-2h-5l4-2 9-3z",
    fill: "#303030"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(309,363)",
    d: "m0 0 6 2h19l-1 2v3l-4 2-2-1h-10l-5-2v-2l-3-2z",
    fill: "#343434"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(411,713)",
    d: "m0 0h1l4 31 4 12v2h-7l3-1-2-3-2-13z",
    fill: "#686868"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(639,103)",
    d: "m0 0h1v8l-1 5v7l-5-2-2-5v-7l2-2 2-3 2 1z",
    fill: "#2E2E2E"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(833,789)",
    d: "m0 0 5 1 11 4 10 4v1l-10 1-11-5-7-3 2-1z",
    fill: "#343434"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(702,766)",
    d: "m0 0 5 1 5 4 3 3 4 1v2l5 2 1 3-7-1-5-3v-2l-9-3-2-2h3l-1-3z",
    fill: "#2A2A2A"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1159,1243)",
    d: "m0 0 8 4 6 2 7 1-2 2 1 3 2 1-8 1-11-3 4-1 3 1 1-3-4-1-3-1v-2l-4-1z",
    fill: "#363636"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1309,424)",
    d: "m0 0h2l-1 4 2-1-2 5-10 8-9 4h-5l3-2 8-4 5-7 5-4z",
    fill: "#1C1C1C"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(843,93)",
    d: "m0 0h1l1 10-1 8-1 5-1 6-2 3-4 27-2 2 3-23 4-25z",
    fill: "#666"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(752,1190)",
    d: "m0 0 14 1h39l-4 3-10 1-23-1-14-2z",
    fill: "#383838"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(759,743)",
    d: "m0 0 3 1v2l3 1 2 7v7l-5-3-6-10h2z",
    fill: "#343434"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1398,865)",
    d: "m0 0h1l1 14 3 3v10l-2-3-1 9-4 5 1-20z",
    fill: "#373737"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(953,1421)",
    d: "m0 0h2v21 4l-2-1-2-5-1-6v-11l3-1z",
    fill: "#161616"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(762,816)",
    d: "m0 0 1 3h2v4l-7 4h-2l-2 4-5 3-3-1 4-5 3-4 5-3z",
    fill: "#161616"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(841,718)",
    d: "m0 0 2 1-5 6-3 1-1 4-4 3-7 1-1-3 4-4 11-6z",
    fill: "#3E3E3E"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(361,1158)",
    d: "m0 0 5 2 3 3 1 6 3 5-2 9-2-4-6-15z",
    fill: "#484848"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(791,766)",
    d: "m0 0h3l-1 5-3 1 1 3 4 1 7 3v1l-9-1-1-1h-6l-4-4z",
    fill: "#FEFEFE"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(785,580)",
    d: "m0 0 4 4 4 6 4 8-3 1-4-6-2 3-2 4h-3l1-5h2v-10l-3-4z",
    fill: "#434343"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1490,904)",
    d: "m0 0h2v8l-6 33-2 1v-8l2-12 3-12z",
    fill: "#1D1D1D"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1159,887)",
    d: "m0 0h1l1 30-2 13-3 1 1-17 1-8z",
    fill: "#262626"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1301,877)",
    d: "m0 0 2 1-2 20-1 2h-2v12h-1l-1 5h-2l5-35z",
    fill: "#5F5F5F"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(965,912)",
    d: "m0 0h8l6 8v4l-5 1-3-7-1-2-6-1h-9l3-2z",
    fill: "#262626"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(436,1358)",
    d: "m0 0 5 1 1 4-1 9-3-4-1-3 2-5-5 4 2 4-4 1-1 9h-1v-16l3-3z",
    fill: "#434343"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(297,681)",
    d: "m0 0h1v14l-3 21h-1l-2-17h2l2-16z",
    fill: "#191919"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1262,352)",
    d: "m0 0h20l11 4v4l-17-4v-1l-14-1z",
    fill: "#3E3E3E"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1292,357)",
    d: "m0 0 4 1 9 7 5 6v2h2l2 5-2 3-2-4-2-1-1-5-4-2-8-7-3-3z",
    fill: "#373737"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(478,1431)",
    d: "m0 0 16 4 5 1h7l4-1v2l-7 2 4 2h-15v-1l7-1-14-2-3-2-4-2z",
    fill: "#373737"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(769,798)",
    d: "m0 0h8v2l4 2 2 4-8-1v2l-4-2-3-3z",
    fill: "#eee"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(954,1447)",
    d: "m0 0 4 1 1 5 1 15 1 7-2-1-5-20z",
    fill: "#1A1A1A"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(755,666)",
    d: "m0 0h1l1 74-4-1 2-1z",
    fill: "#A3A3A3"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(796,956)",
    d: "m0 0 1 2 5-2-6 7-7 8-2 6-1-3 1-4h-2v-3l-9-3 4-1 6 3 4-1z",
    fill: "#C0C0C0"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(656,197)",
    d: "m0 0h1l4 22-1 8h-1v-6l-3-3-1-8v-10z",
    fill: "#5B5B5B"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(979,939)",
    d: "m0 0h4l1 2v11l-1 16h-1l-1-14-2-6z",
    fill: "#131313"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(291,692)",
    d: "m0 0h1l1 8v11l-1 9-2 1-2-1 1-10z",
    fill: "#404040"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1055,187)",
    d: "m0 0 3 1 1 9 1 5-5 2-2-7v-7h2z",
    fill: "#5A5A5A"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(723,789)",
    d: "m0 0 2 1-3 4-10 4-8 2-1-3 11-5z",
    fill: "#444"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(113,647)",
    d: "m0 0 1 3-4 24-2-3 1-18 3-5z",
    fill: "#1A1A1A"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(773,1322)",
    d: "m0 0h1l1 12v14l-2 2-2 8-1-4z",
    fill: "#414141"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(786,805)",
    d: "m0 0 6 1 8 6v2l4 1 2 2-6-1-4-2-1 3-4-7-5-3z",
    fill: "#383838"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1225,1314)",
    d: "m0 0h2v2l7 2v2l4 2-3 2-6-1-5-4z",
    fill: "#1F1F1F"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(750,826)",
    d: "m0 0 1 2-4 5 6-2 3-3h2l-2 5-3 1v2l-4 2v-2l-6 2-1-3z",
    fill: "#5A5A5A"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(111,627)",
    d: "m0 0h1l1 11-3 1v3h2v6l-2 5-3 1 1-12z",
    fill: "#3B3B3B"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(983,739)",
    d: "m0 0h2l1 16v30h-1l-1-13-1-5 1-6z",
    fill: "#515151"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(966,689)",
    d: "m0 0 5 2 1 9h-3l-2-3-4 2-5 1 4-5h2z",
    fill: "#2A2A2A"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(653,186)",
    d: "m0 0 17 1-2 2-12 2h-4l-2 3v-2l-2-1 2-2h3z",
    fill: "#131313"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(645,156)",
    d: "m0 0 2 2 1 10-2 6v5h-2l-1-8 1-2h-2v-6l3-1z",
    fill: "#2C2C2C"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(651,1086)",
    d: "m0 0 4 1-2 1h7l-3 2-11 4h-7l2-1v-2z",
    fill: "#363636"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(812,746)",
    d: "m0 0 2 1-12 12-8 7-7 4-5 4 2-4 16-12z",
    fill: "#B5B5B5"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(757,783)",
    d: "m0 0 4 1 1 2-4 2-10 2h-8v-2l2-1 9-1z",
    fill: "#303030"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(585,1011)",
    d: "m0 0h1l3 22-1 4-1-3-3-1v-10z",
    fill: "#494949"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(746,1503)",
    d: "m0 0 3 1 5 1 1 3-4 2-14-1 3-2h4v-2h2z",
    fill: "#272727"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(729,788)",
    d: "m0 0 6 1 2 2-15 5 1-5 2-2z",
    fill: "#252525"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(763,919)",
    d: "m0 0h1l3 32v5h-2l-2-4 1-4-1-13z",
    fill: "#747474"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(766,800)",
    d: "m0 0 4 4 3 4-1 5-2 3v-4l-5 2 3-4v-3h-3v-6z",
    fill: "#484848"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(774,777)",
    d: "m0 0 4 1v3l-7 2h-9l3-3 3-2z",
    fill: "#E8E8E8"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1256,358)",
    d: "m0 0 3 1-9 5-9 7-4 6-2-3 7-8 10-6z",
    fill: "#979797"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1132,1202)",
    d: "m0 0h1l1 6 1-5h3v10l-1 2h-2l-2 4-1-3z",
    fill: "#424242"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1272,616)",
    d: "m0 0 2 1-3 3h6v2h10v1h-12v2l3 1-6-1-5-2v-3z",
    fill: "#5C5C5C"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(325,1143)",
    d: "m0 0h3v2h8v1l-14 2-8 2-5 3-2-1 5-4z",
    fill: "#353535"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(793,797)",
    d: "m0 0 3 1 2 5 2 2 1 6 5 5-6-2-5-6v-3z",
    fill: "#9F9F9F"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1255,360)",
    d: "m0 0 5 1-3 2-12 7-5 4-2-1 9-8z",
    fill: "#505050"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(943,1395)",
    d: "m0 0 1 3v4l-5-1h-9l4-2-2-2z",
    fill: "#383838"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(591,914)",
    d: "m0 0 1 4-1 5h-2v7h-2v10l-3 1 1-9z",
    fill: "#3C3C3C"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(582,761)",
    d: "m0 0 2 2 2-1-1 18-2 1-1-11z",
    fill: "#363636"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(849,715)",
    d: "m0 0 1 2-2 4-11 7h-3l1-3 4-2 4-4 4-2z",
    fill: "#202020"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(664,270)",
    d: "m0 0h2l1 6-4 12 3 1h-8l4-5v-11h2z",
    fill: "#4B4B4B"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(781,774)",
    d: "m0 0 6 3h5l5 2 7 1v1h-9l-13-2-3-3z",
    fill: "#D7D7D7"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1156,622)",
    d: "m0 0 2 3 2 7-1 4-3 3-1-5v-11z",
    fill: "#3B3B3B"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(236,541)",
    d: "m0 0 2 2-3 7-1 5h-2v-2h-3l3-10 1 2h2z",
    fill: "#414141"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1298,434)",
    d: "m0 0 2 1-1 3-11 6-3 1-2-4 12-5z",
    fill: "#333"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(780,988)",
    d: "m0 0h18l-1 3h-25v-1h8z",
    fill: "#ABABAB"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(958,677)",
    d: "m0 0 5 5 6 5 1 4-3-1-2 2-1-6-3-1-4-6z",
    fill: "#606060"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(448,343)",
    d: "m0 0 5 4 2 5v3l-3 1-3-5-2-6z",
    fill: "#2C2C2C"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1054,181)",
    d: "m0 0 2 1-1 8h-2v2h-4l1-7z",
    fill: "#171717"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(588,838)",
    d: "m0 0h1l2 25h-2l-1 2z",
    fill: "#9F9F9F"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(582,746)",
    d: "m0 0h1l1 6h1v10l-2 2-1 6h-1v-13z",
    fill: "#4E4E4E"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(967,480)",
    d: "m0 0h32l3 2-12-1v2l-23-2z",
    fill: "#8A8A8A"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(960,476)",
    d: "m0 0 3 2 32 1v1l-27 1-2 1-1 2-1-4-4-2z",
    fill: "#C7C7C7"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(784,979)",
    d: "m0 0 1 3-3 5-2 3-11 1 1-4h8l4-4z",
    fill: "#5D5D5D"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(764,798)",
    d: "m0 0h1l1 8 3 1-1 4-5 4-1-4z",
    fill: "#BCBCBC"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1161,714)",
    d: "m0 0h1v12l-2 8-2-1 1-13z",
    fill: "#151515"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(294,1178)",
    d: "m0 0h1l2 19 2 8-2-1v-2h-3z",
    fill: "#969696"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(950,659)",
    d: "m0 0 2 2 4 10-1 2-2-1v2h-2v-4l-2-1 2-2-2-3z",
    fill: "#5B5B5B"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(940,476)",
    d: "m0 0h10v1l-14 2-7 2v-2h-6v-1z",
    fill: "#898989"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(436,1358)",
    d: "m0 0 5 1 1 4-1 9-3-4-1-3 2-5-5 1-2 2-1-3z",
    fill: "#595959"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1364,1139)",
    d: "m0 0 12 5 11 1v1h-17l-3-3-3-1z",
    fill: "#393939"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(761,951)",
    d: "m0 0 4 3v2l3 1 1 7-4-1-4-9z",
    fill: "#4B4B4B"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(769,1362)",
    d: "m0 0 2 4-1 13h-2l-1 5-1-4z",
    fill: "#696969"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(802,987)",
    d: "m0 0h5l-3 2 9 1v1h-16l-8-1v-1z",
    fill: "#444"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1443,843)",
    d: "m0 0h11l4 2-4 1h-12l-2-2z",
    fill: "#393939"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(610,666)",
    d: "m0 0h1v7l-4 7-6 3 2-5h2v-3h2l1-4z",
    fill: "#343434"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1253,357)",
    d: "m0 0h3v2l-10 5h-3l-1-4 5-1h2z",
    fill: "#3D3D3D"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1082,245)",
    d: "m0 0 5 5 10 12h-3l-12-13-1-3z",
    fill: "#1E1E1E"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1048,191)",
    d: "m0 0 5 1 1 10-5-3z",
    fill: "#383838"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(765,984)",
    d: "m0 0 4 2v5h-7l-4-4 7 1z",
    fill: "#272727"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(819,830)",
    d: "m0 0 7 5v2l3 1-2 1-10-4v-2l-3-1h5z",
    fill: "#565656"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(787,762)",
    d: "m0 0 2 1-4 5-6 3-4-1 1-3-1-2 7 1z",
    fill: "#AEAEAE"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(642,1371)",
    d: "m0 0 1 4-1 10h-2l-1 7h-2l2-11z",
    fill: "#717171"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(621,675)",
    d: "m0 0 9 1 12 4-1 3-5-2-15-5z",
    fill: "#696969"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(958,887)",
    d: "m0 0h8l-1 2h-4v2h-10l-1-2z",
    fill: "#484848"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(669,183)",
    d: "m0 0h5l-4 1v3h-15l1-2z",
    fill: "#4B4B4B"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1220,1312)",
    d: "m0 0 4 1 1 2-2 3zm5 1 5 1 6 3 1 2-6-1-4-2v-2z",
    fill: "#4D4D4D"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1397,933)",
    d: "m0 0h2v8h-7v-2l2-1 1-4z",
    fill: "#181818"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1424,841)",
    d: "m0 0h13l5 1-4 2h-9l-5-2z",
    fill: "#404040"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(413,816)",
    d: "m0 0 3 3 1 6-3-1-3 7h-1v-5l2-7z",
    fill: "#444"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(797,1191)",
    d: "m0 0h8l-4 3-10 1-4-2 1-1z",
    fill: "#333"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(414,823)",
    d: "m0 0 2 1-1 9-2 7h-1l1-16z",
    fill: "#1B1B1B"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(953,672)",
    d: "m0 0 4 2 1 5-9-2v-2l4-1z",
    fill: "#1B1B1B"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(508,1435)",
    d: "m0 0h2v2l-7 2 4 2h-15v-1l7-1v-2z",
    fill: "#3F3F3F"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1245,1318)",
    d: "m0 0h8v1l-5 1 5 1-4 2-8-2-2-2z",
    fill: "#262626"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(937,1301)",
    d: "m0 0h1l1 16-2 1-1-3v-10z",
    fill: "#5B5B5B"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(752,825)",
    d: "m0 0 2 1v2l2 1-5 4-5 1z",
    fill: "#353535"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(769,769)",
    d: "m0 0h7v3l-4 1-1 3 3 2h-8l2-1v-2l2-1z",
    fill: "#919191"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(952,210)",
    d: "m0 0h3l-1 8-3 3-2 4-1-2z",
    fill: "#454545"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(826,202)",
    d: "m0 0 2 1v8l-3 6h-1v-7z",
    fill: "#5E5E5E"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(637,1392)",
    d: "m0 0 2 2-1 11-2 1-1-7z",
    fill: "#606060"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1159,1243)",
    d: "m0 0 8 4 6 2v1l-6 1-4-2v-2l-4-1z",
    fill: "#3B3B3B"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(302,1147)",
    d: "m0 0 2 1-4 6-7 5 2-5 5-5z",
    fill: "#484848"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(794,1013)",
    d: "m0 0 9 5 4 4-5-1-5-2-3-4z",
    fill: "#545454"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(801,949)",
    d: "m0 0h2v6l-4 3h-2l1-6z",
    fill: "#232323"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(834,783)",
    d: "m0 0m-2 1h2v2h-2l1 5h-5l-1-3-2-2z",
    fill: "#313131"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(845,775)",
    d: "m0 0 2 1-5 5-4 2-4-1 4-4z",
    fill: "#575757"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(930,679)",
    d: "m0 0 2 1-4 4-5 2-3-1 4-4z",
    fill: "#1A1A1A"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1158,634)",
    d: "m0 0h1v14l-2 2-1-3v-8z",
    fill: "#101010"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(984,531)",
    d: "m0 0h1l2 11v8h-2l-1-6z",
    fill: "#757575"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(654,231)",
    d: "m0 0h3l1 11-3 1-1-4z",
    fill: "#1A1A1A"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(944,1393)",
    d: "m0 0h1l2 7 1 3 2 2-3 4-3-7-1-4z",
    fill: "#161616"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(949,1375)",
    d: "m0 0h1l1 10-1 5-2-1-1-9z",
    fill: "#555"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(191,700)",
    d: "m0 0h1l1 12-2 4-2-1z",
    fill: "#636363"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(486,1437)",
    d: "m0 0 13 1 2 2h-14z",
    fill: "#1E1E1E"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(804,929)",
    d: "m0 0h3l-1 9-3 4v-10z",
    fill: "#515151"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(965,912)",
    d: "m0 0h8v3l-5-1-4 1h-9l3-2z",
    fill: "#818181"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1401,846)",
    d: "m0 0h2l1 3v7l-4 1z",
    fill: "#696969"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(701,798)",
    d: "m0 0h2l-1 4-9 4-2-2z",
    fill: "#3B3B3B"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(702,766)",
    d: "m0 0 5 1 3 4-2 3-4-1-2-2h3l-1-3z",
    fill: "#383838"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(758,633)",
    d: "m0 0 1 4 2 4-1 5-2 7h-1v-19z",
    fill: "#5D5D5D"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(411,615)",
    d: "m0 0 1 4v10l-2 1v-2h-2l2-10z",
    fill: "#3E3E3E"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1108,263)",
    d: "m0 0 4 4 3 5-1 2-5-4-2-3z",
    fill: "#5F5F5F"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1050,200)",
    d: "m0 0 5 1v3h2l-1 4h-4z",
    fill: "#2D2D2D"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1483,938)",
    d: "m0 0h1v9h-4l1-7z",
    fill: "#2D2D2D"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(746,830)",
    d: "m0 0m-2 1 2 1-3 3-1 3-6 4-2-1 5-6z",
    fill: "#626262"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(750,788)",
    d: "m0 0h7v2l6 3-3 2-8-5-4-1z",
    fill: "#8F8F8F"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(920,681)",
    d: "m0 0 4 1-3 1-1 4-3 1 1-3h-2l-1 2-4-2z",
    fill: "#393939"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(945,1353)",
    d: "m0 0h1l1 10-1 5-2-2v-10z",
    fill: "#565656"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(304,1147)",
    d: "m0 0 3 1-2 4-4 4h-2l2-6z",
    fill: "#333"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(809,840)",
    d: "m0 0 3 1-1 7-1 2h-2v-9z",
    fill: "#2B2B2B"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(860,799)",
    d: "m0 0 10 3 6 3-1 2-14-5z",
    fill: "#3F3F3F"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(709,771)",
    d: "m0 0 5 1 3 5-6-1-3-2z",
    fill: "#202020"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(812,746)",
    d: "m0 0 2 1-12 12-2 1 2-4z",
    fill: "#BEBEBE"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(971,509)",
    d: "m0 0h3l2 6v5h-2l-3-8z",
    fill: "#1D1D1D"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(952,1395)",
    d: "m0 0 2 3 1 8-3 1-1-2v-8z",
    fill: "#5E5E5E"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1486,932)",
    d: "m0 0h1v9l-2 5h-1v-8z",
    fill: "#171717"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1492,859)",
    d: "m0 0h1l1 10 2 2-3 3-2 3z",
    fill: "#4D4D4D"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(793,808)",
    d: "m0 0 5 2 2 4 4 1 2 2-6-1-5-4z",
    fill: "#515151"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(781,797)",
    d: "m0 0 5 2 4 4 4 2 1 3-5-2-9-8z",
    fill: "#A8A8A8"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(111,627)",
    d: "m0 0h1l1 11-3 1-1 3 1-10z",
    fill: "#3D3D3D"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(809,835)",
    d: "m0 0h3v2l4 1h-3v7l-1-4-4-2z",
    fill: "#676767"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(756,828)",
    d: "m0 0h2l-2 5-3 2h-6l4-3z",
    fill: "#A1A1A1"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(696,804)",
    d: "m0 0m-2 0 2 1-1 4-6 2v-3l2-3z",
    fill: "#101010"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(753,741)",
    d: "m0 0 4 2 2 3-1 2h-3l-4-5z",
    fill: "#272727"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(789,585)",
    d: "m0 0h4l1 5h2l2 3-1 3v-2l-3-1-5-7z",
    fill: "#bbb"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1250,355)",
    d: "m0 0 6 1-3 2-5 3-2-1v-3z",
    fill: "#595959"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1364,1031)",
    d: "m0 0h3l-1 4-2 5-2-2-2 1 2-5z",
    fill: "#434343"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(774,772)",
    d: "m0 0 4 1v3l-8 1 2-4z",
    fill: "#424242"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1256,358)",
    d: "m0 0 3 1-9 5-4 3h-2l2-4z",
    fill: "#A3A3A3"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1077,152)",
    d: "m0 0 2 1-1 2h-2l-1 3-5 2-3-1h2v-2z",
    fill: "#323232"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(306,1212)",
    d: "m0 0 10 6-1 2-6-2-3-4z",
    fill: "#eee"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1355,1130)",
    d: "m0 0 7 6 1 2-4 1-5-6z",
    fill: "#424242"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(950,1091)",
    d: "m0 0 10 1-3 1v2l-8-1z",
    fill: "#2C2C2C"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1410,839)",
    d: "m0 0 14 1v1l-5 1h-7z",
    fill: "#2E2E2E"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(883,810)",
    d: "m0 0 5 1v2h3v2l4 1v2l-4-1-8-6z",
    fill: "#525252"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(102,681)",
    d: "m0 0 3 2v7l-4 2z",
    fill: "#414141"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(980,677)",
    d: "m0 0 9 1 5 2-3 2-6-2-5-2z",
    fill: "#707070"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(834,154)",
    d: "m0 0 2 1v5l-3 7-1-4z",
    fill: "#636363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9012a874501c8a546a20c40d05ba29e1.svg";
export { ForwardRef as ReactComponent };